export default __webpack_public_path__ + "static/media/recruiting-process.535044f3.png";